import styled from 'styled-components';

import { colors, breakPoints } from '@/styles';

export const Pagination = styled.div`
  ul {
    display: inline-flex;
    align-items: center;
    font-size: 14px;
    margin: 0;
    padding: 0;
    flex-direction: row;
    list-style-type: none;

    li {
      &:hover:not(.active):not(.disabled):not(.previous):not(.next):not(.break) {
        a {
          background-color: ${colors.semantic.pagination.hover.background};
          color: ${colors.semantic.pagination.hover.color};
        }
      }
      a {
        display: inline-block;
        padding: 10px;
        line-height: 1;
        min-width: 2.5rem;
        text-align: center;
        border: ${colors.semantic.pagination.border} 1px solid;
        cursor: pointer;
      }
      &.previous a,
      &.next a,
      &.break a {
        border-color: transparent;
      }
      &.active a {
        background-color: ${colors.semantic.pagination.active.background};
        border-color: transparent;
        color: ${colors.semantic.pagination.active.color};
      }
      &.disabled a {
        color: ${colors.semantic.pagination.disabled.color};
      }
      &.disable,
      &.disabled a {
        cursor: default;
      }
    }
  }

  @media (max-width: ${breakPoints.mobile}) {
    ul {
      font-size: 12px;
      li a {
        padding: 8px;
      }
    }
  }
`;

export const CompactPagination = styled(Pagination)`
  ul {
    font-size: 12px;

    li {
      padding: 2px;
    }
    li a {
      border: none;
      border-radius: 3px;
      padding: 2px 4px;
      min-width: 1.25rem;
    }
  }
  svg {
    height: 12px;
  }
  @media (max-width: ${breakPoints.mobile}) {
    ul {
      font-size: 12px;
      li a {
        padding: 8px;
      }
    }
  }
`;
